import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react';

interface Props {
  name: string;
  value: string;
}

const AttributeTooltip = ({ name, value }: Props) => {
  const textElementRef = useRef<HTMLInputElement | null>(null);

  const [hoverStatus, setHover] = useState(false);

  const compareSize = () => {
    if (textElementRef && textElementRef.current) {
      const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
      setHover(compare);
    }
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
  }, []);

  useEffect(
    () => () => {
      window.removeEventListener('resize', compareSize);
    },
    []
  );

  const renderAttributeValue = (attributeValue: string) => {
    try {
      const url = new URL(attributeValue);
      if (!url.host || !url.hostname || !url.pathname) throw new Error('Not url');
      return <a href={url.href}>{url.href}</a>;
    } catch (e) {
      return attributeValue;
    }
  };

  return (
    <Tooltip
      title={`${name}: ${value.toString()}`}
      disableHoverListener={!hoverStatus}
      PopperProps={{ 'data-testid': 'attribute-tooltip' } as any}
    >
      <div
        data-testid="attribute-label"
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%'
        }}
      >
        <b>{`${name}: `}</b>
        {renderAttributeValue(value.toString())}
      </div>
    </Tooltip>
  );
};

export default AttributeTooltip;
